export const POST_UPLOAD_FILES_REQUEST = "POST_UPLOAD_FILES_REQUEST"
export const POST_UPLOAD_FILES_SUCCESS = "POST_UPLOAD_FILES_SUCCESS"
export const POST_UPLOAD_FILES_FAIL = "POST_UPLOAD_FILES_FAIL"